// Google Analytics 4 Configuration
// Up Cleaning Pro Analytics

export const initGA4 = () => {
  // Measurement ID from Google Analytics
  const GA_MEASUREMENT_ID = 'G-PD8G8VYXSD';

  // Create script tag
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: true
  });

  console.log('✅ Google Analytics initialized:', GA_MEASUREMENT_ID);
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('📊 Event tracked:', eventName, eventParams);
  }
};

// Track page views
export const trackPageView = (pagePath) => {
  if (window.gtag) {
    window.gtag('config', 'G-PD8G8VYXSD', {
      page_path: pagePath
    });
  }
};

// Track Book Now button clicks
export const trackBookNow = (location) => {
  trackEvent('book_now_click', {
    button_location: location,
    page: window.location.pathname
  });
};

// Track phone clicks
export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    phone_number: '(267) 613-4373',
    page: window.location.pathname
  });
};

// Track email clicks
export const trackEmailClick = () => {
  trackEvent('email_click', {
    email: 'scheduleup@upcleaning.pro',
    page: window.location.pathname
  });
};

// Track service views
export const trackServiceView = (serviceName) => {
  trackEvent('service_view', {
    service_name: serviceName,
    page: window.location.pathname
  });
};

// Track section scrolls
export const trackSectionView = (sectionName) => {
  trackEvent('section_view', {
    section: sectionName,
    page: window.location.pathname
  });
};

// Track booking completion (Thank You page)
export const trackBookingCompleted = () => {
  trackEvent('booking_completed', {
    value: 150, // Estimated average booking value
    currency: 'USD',
    page: window.location.pathname
  });
};
